import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ReportDetailsViewLazy = React.lazy(
	() => import(/* webpackChunkName : 'ReportDetailsView' */ './components')
);

export default (store) => {
	return {
		path: 'report-configure/progress-reports/:campusId/grade-view/:reportRunId',
		element: <AsyncLoading component={<ReportDetailsViewLazy />} />,
		children: [],
	};
};
